module.exports = __webpack_public_path__ + "static/media/mr.bf379763.svg";